import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'upsc-auth-error',
  templateUrl: './auth.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthErrorComponent {
  errorOccurred: boolean;
  showCodeVerification: boolean;
  emailAddress: string;

  constructor(
    private msalService: MsalService
  ) {
    this.msalService.instance.clearCache()
    sessionStorage.clear();
    localStorage.clear();
    this.errorOccurred = true;
    this.showCodeVerification = false;
  }

  checkVerification(event: any) {}
}
